import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const Sitemap = props => {
  const siteElements = props.listItems.map(({ title, url }, index) => (
    <li className='sitemap-item' key={index}>
      <Link to={url}>{title}</Link>
    </li>
  ))
  return (
    <ul className='sitemap' style={props.style}>
      {siteElements}
    </ul>
  )
}

Sitemap.propTypes = {
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string
    })
  )
}

export default Sitemap



// WEBPACK FOOTER //
// ./src/ui/footer/sitemap.js